"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IEventParams.js.map